import { FunctionComponent, memo, useCallback, useContext, useMemo } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { DetailsModalContext } from '../../../../context';
import {
  StoryCard,
  StoryCardContentHeadline,
  StoryCardPostContent,
  StoryCardType,
} from '../../../../services';
import { layoutPath, useCardDate } from '../../../../shared';

import classes from './DisruptionCard.module.scss';

interface DisruptionCardProps {
  card: StoryCard;
  iconUrl?: string;
}

export const DisruptionCard: FunctionComponent<DisruptionCardProps> = memo(({ card, iconUrl }) => {
  const { id: cardId, type, storyId, content, dateToDisplay } = card;

  const title = useMemo(() => {
    if (type === StoryCardType.POST) {
      return (content as StoryCardPostContent).title;
    }
    return (content as StoryCardContentHeadline).headline;
  }, [content, type]);

  const date = useCardDate(dateToDisplay);

  const navigate = useNavigate();

  const { setDetailsModalData } = useContext(DetailsModalContext);

  const handleClick = useCallback(
    () =>
      isMobileOnly
        ? navigate(layoutPath(`/details/${storyId}/${cardId}`))
        : setDetailsModalData({ storyId, cardId }),
    [cardId, navigate, setDetailsModalData, storyId]
  );

  return (
    <button type={'button'} className={classes['card']} onClick={handleClick}>
      {iconUrl && <img src={iconUrl} className={classes['card__icon']} alt={''} />}
      {title && <div className={classes['card__content-title']}>{title}</div>}
      {date && <div className={classes['card__content-date']}>{date}</div>}
    </button>
  );
});
